import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'epm-example',
  template: `
    <p>
      epm-example works!
    </p>
  `,
  styles: []
})
export class EpmExampleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
